import {
  type LockupCategoryDiscount,
  type LockupXForY,
  type LockupType,
  type LockupNonOffer,
  type LockupPercentageDiscount,
} from '@/features/cms/components/CMS/types'
import styled from 'styled-components'
import { Body, Headline } from '@shipt/design-system-typography'

const NonOfferLockup = ({ data }: { data: LockupNonOffer }) => (
  <>
    {!!data.eyebrow && <Body strong>{data.eyebrow}</Body>}
    {!!data.heading && (
      <Headline size="xl" as="h3">
        <span>{data.heading}</span>
      </Headline>
    )}
  </>
)

const PercentageDiscountLockup = ({ data }: { data: LockupPercentageDiscount }) => (
  <>
    {!!data.eyebrow && <Body strong>{data.eyebrow}</Body>}
    <Headline size="xl" as="h3">
      <span>{data.percent_off}%</span>
      <Trailing>{data.trailing_text}</Trailing>
    </Headline>
  </>
)

const CategoryDiscountLockup = ({ data }: { data: LockupCategoryDiscount }) => (
  <>
    {!!data.eyebrow && <Body strong>{data.eyebrow}</Body>}
    <Headline size="xl" as="h3">
      <span>${data.dollar_amount}</span>
      <Trailing>{data.trailing_text}</Trailing>
    </Headline>
  </>
)

const XForYLockup = ({ data }: { data: LockupXForY }) => (
  <Headline size="xl" as="h3">
    <Leading>
      {data.number_of_items} {data.leading_text}{' '}
    </Leading>
    <span>${data.dollar_amount}</span>
  </Headline>
)

export const PromoLockup = ({ lockup }: { lockup: LockupType }) => {
  switch (lockup.content_type_id) {
    case 'lockup_non_offer':
      return <NonOfferLockup data={lockup.data} />

    case 'lockup_percentage_discount':
      return <PercentageDiscountLockup data={lockup.data} />

    case 'lockup_category_discount':
      return <CategoryDiscountLockup data={lockup.data} />

    case 'lockup_x_for_y':
      return <XForYLockup data={lockup.data} />

    default:
      return null
  }
}

const Leading = styled.span`
  font-size: 1.125rem;
  vertical-align: baseline;
`

const Trailing = styled(Leading)`
  vertical-align: top;
  margin-left: 2px;
`
